/**
 * @module
 */
define('eventLoggerPwa',["routes", "ajaxHelper", "analyticsHelper", "performanceEventsQueue"], function (routes, ajax, analyticsHelper, performanceEventsQueue) {
  var commIdHd = 0;
  var builderIdHd = 0;
  var siteRoot = document.getElementById("nhs_siteRoot");
  var marketId = document.getElementById("nhs_marketId");
  var performanceLogUrl = routes.performanceLog;

  if (siteRoot) {
    siteRoot = siteRoot.value;
  } else {
    siteRoot = "";
  }
  if (marketId) {
    marketId = marketId.value;
  } else {
    marketId = 0;
  }

  /**
   * Redirects the window
   * @function
   * @param {Event} e Event
   * @param {String} url URL
   * @param {*} newWin New Window
   */
  function redirect(e, url, newWin) {
    if (e.stopPropagation) {
      e.stopPropagation();
    }

    if (url) {
      if (newWin) {
        window.open(url);
      } else {
        window.location.href = url;
      }
    }
  }

  /**
   * Checks if the Google Analytics library has been downloaded yet
   * @function
   */
  function isGaLoaded() {
    return typeof (ga) === "function" && typeof (ga.getAll) === "function";
  }

  /**
   * Handles the url event log, if GA is ready then we log the event,
   * otherwise we are going to enqueue it and wait for the pageLoad event before trying to log them
   * @function
   * @param {String} url String
   * @param {String} isGaReady String
   * @param {Boolean} areGaParamsNeeded Boolean
   * @param {Boolean} isAsync Boolean
   */
  function handleLogEvent(url, isGaReady, areGaParamsNeeded, isAsync) {
    if (!isGaReady) {
      performanceEventsQueue.enqueueEvent(url);
    } else {
      if (areGaParamsNeeded) {
        url = analyticsHelper.addAnalyticsUrlParameters(url);
      }
      ajax.postRequest(url, { async: isAsync });
    }
  }

  /**
   * Logs a view using parameters
   * @function
   * @param {String} url 
   * @param {Number} eventCode 
   * @param {*} parameters 
   */
  function logViewWithParameters(url, eventCode, parameters) {
    var isGaReady = isGaLoaded();
    var result = createUrl(url, parameters, isGaReady);
    url = result.url;
    var communityId = result.communityId;
    var specId = result.specId;
    var planId = result.planId;

    var async = true;

    if (typeof parameters.async != "undefined") {
      async = parameters.async;
    }

    if ("undefined" === typeof parameters.gaBuilderCommunityList || null === parameters.gaBuilderCommunityList) {
      /*
       * Backwards compatibility. This method was changed to pass different lists to the Google Analytics controller and the Log Controller, because in some scenarios
       * Log Controller information was formatted as "{Builder ID} {Comm ID} {MPC ID} {Market ID}", while the Google Analytics Controller is looking for the Comm ID at the 
       * last position from that given string, thus we were doing calls passing Market ID as Comm ID. But, this method has 223 possible usages according to ReSharper so
       * we need to provide a fallback to avoid passing an undefined value for scenarios where the Builder Community List had the correct information.
       */
      parameters.gaBuilderCommunityList = parameters.builderCommunityList;
    }

    //GA Performance event (with enhaced ecomm)
    logGoogleEcommerceEvent(eventCode, communityId, specId, planId, null, parameters.gaBuilderCommunityList, parameters.homeList, async, parameters.parentCommunityId !== 0);
    url = ajax.getAbsolutePathRequest(url);

    handleLogEvent(url, isGaReady, false, async);
  }

  function addAnalyticsUrlParameters(url) {
    var analyticsValues = analyticsHelper.getGoogleAnalyticsValues(["clientId", "userId"]);

    var gaClientId = analyticsValues["clientId"] !== undefined
      ? analyticsValues["clientId"]
      : "";
    var gaUserId = analyticsValues["userId"] !== undefined
      ? analyticsValues["userId"]
      : "";

    if (gaClientId) {
      url = url + "/GAClientId-" + gaClientId;
    }

    if (gaUserId) {
      url = url + "/GAUserId-" + gaUserId;
    }

    return url;
  }

  /**
   *
   *
   * @param {string} url
   * @param {*} parameters
   */
  function logViewWithoutEcommerce(url, eventCode, parameters) {
    var isGaReady = isGaLoaded();
    var result = createUrl(url, parameters, isGaReady);
    url = result.url;

    var async = true;

    if (typeof parameters.async != "undefined") {
      async = parameters.async;
    }

    if ("undefined" === typeof parameters.gaBuilderCommunityList ||
      null === parameters.gaBuilderCommunityList) {
      /*
       * Backwards compatibility. This method was changed to pass different lists to the Google Analytics controller and the Log Controller, because in some scenarios
       * Log Controller information was formatted as "{Builder ID} {Comm ID} {MPC ID} {Market ID}", while the Google Analytics Controller is looking for the Comm ID at the 
       * last position from that given string, thus we were doing calls passing Market ID as Comm ID. But, this method has 223 possible usages according to ReSharper so
       * we need to provide a fallback to avoid passing an undefined value for scenarios where the Builder Community List had the correct information.
       */
      parameters.gaBuilderCommunityList = parameters.builderCommunityList;
    }

    url = ajax.getAbsolutePathRequest(url);
    handleLogEvent(url, isGaReady, false, async);
  }

  /**
   * Appends the parameters to the URL used to log events
   * @function
   * @param {String} url the base URL used to append the parameters
   * @param {String} parameters the parameters object used to append the parameters to the URL
   */
  function createUrl(url, parameters, isGaReady) {
    var communityId = 0, specId = 0, planId = 0;

    if (parameters.builderId) {
      url = url + "/builder-" + parameters.builderId;
    }

    if (parameters.communityId || parameters.commId) {
      url = url + "/community-" + (parameters.communityId || parameters.commId);
      communityId = (parameters.communityId || parameters.commId);
    }

    if (parameters.parentCommunityId || parameters.parentCommId) {
      url = url + "/parentcommunityid-" + (parameters.parentCommunityId || parameters.parentCommunityId);
    }

    if (parameters.communityList) {
      url = url + "/communitylist-" + parameters.communityList;
    }

    if (parameters.marketId) {
      url = url + "/market-" + parameters.marketId;
    }

    if (parameters.planId) {
      url = url + "/planid-" + parameters.planId;
      planId = parameters.planId;
    }

    if (parameters.specId) {
      url = url + "/specid-" + parameters.specId;
      specId = parameters.specId;
    }

    if (parameters.basicListingId) {
      url = url + "/basiclistingid-" + parameters.basicListingId;
    }

    if (parameters.refer) {
      url = url + "/refer-" + parameters.refer;
    }

    if (parameters.totalHomes) {
      url = url + "/totalhomes-" + parameters.totalHomes;
    }

    if (isGaReady) {
      url = analyticsHelper.addAnalyticsUrlParameters(url);
    }

    if (parameters.builderCommunityList) {
      url = url + "?buildercommunitylist=" + parameters.builderCommunityList;
    }

    if (parameters.basicListingList) {
      url = url + "?basiclistinglist=" + parameters.basicListingList;
    }

    if (parameters.homeList) {
      url = url + "?homeList=" + parameters.homeList;
    }

    return {
      url: url,
      communityId: communityId,
      specId: specId,
      planId: planId
    };
  }

  /**
   * Logs a view
   * @function
   * @param {String} url URL
   * @param {Number} eventCode Event code
   * @param {Number} cid Community Id
   * @param {Number} bid Builder Id
   * @param {Number} planId Plan Id
   * @param {Number} specId Spec Id
   * @param {Number} bsId BS Id
   */
  function logView(url, eventCode, cid, bid, planId, specId, bsId) {
    if (url.indexOf("http://") < 0) {
      url = url.replace(" ", "").replace("//", "/");
    }

    var hdPage = planId > 0 || specId > 0;

    if (cid === 0 && hdPage) {
      cid = commIdHd;
    }

    if (bid === 0 && hdPage) {
      bid = builderIdHd;
    }

    //Log to custom via http req 
    if (bsId === 0)
      url = url + "/builder-" + bid + "/community-" + cid + "/planid-" + planId + "/specid-" + specId + "/market-" + marketId;
    else
      url = url + "/basiclistingid-" + bsId + "/market-" + marketId;

    var isGaReady = isGaLoaded();
    handleLogEvent(url, isGaReady, true, true);

    //GA Performance event (with enhaced ecomm)
    logGoogleEcommerceEvent(eventCode, cid, specId, planId, null);
  }

  /**
   * Logs a Google Ecommerce Event
   * @function
   * @param {String} eventName Event name
   * @param {Number} communityId Community Id
   * @param {Number} specId Spec Id
   * @param {Number} planId Plan Id
   * @param {String} builderName Builder's name
   * @param {Number[]} communitiesIdsList Communities Id List
   * @param {Number[]} homesIdsList Homes Id List
   */
  function logGoogleEcommerceEvent(eventName, communityId, specId, planId, builderName, communitiesIdsList, homesIdsList, async, isMpc) {
    isMpc = isMpc || false;
    var params = {
      "eventName": eventName,
      "communityId": typeof (communityId) != "undefined" && communityId != null ? communityId : 0,
      "specId": typeof (specId) != "undefined" && specId != null ? specId : 0,
      "planId": typeof (planId) != "undefined" && planId != null ? planId : 0,
      "builderName": builderName,
      "communitiesIdsList": communitiesIdsList,
      "homesIdsList": homesIdsList,
      "isMpc": isMpc
    };
    performanceLogUrl = ajax.getAbsolutePathRequest(performanceLogUrl);
    ajax.postRequest(performanceLogUrl, {
      async: async ? async : true,
      data: params,
      requestHeaders: [
        {
          name: "Content-Type",
          value: "application/json"
        }
      ],
      success: function (result) {
        // The GetDataLayerPush method of the Google Analytics Controller returns a js that needs to be executed
        eval(result);
      }
    });
  }

  /**
   * Creates an EventLogger instance
   * @constructor
   */
  function EventLogger() { };

  /**
   * Logs and Redirects
   * @method
   * @param {Event} e Event
   * @param {String} url Url
   * @param {Number} eventCode Event code
   * @param {Number} cid Community Id
   * @param {Number} bid Builder Id
   * @param {Number} pid Plan Id
   * @param {Number} sid Spec Id
   * @param {Number} mid Market Id
   * @param {Boolean} external If the redirect is to an external page
   * @returns {Boolean} False
   */
  EventLogger.prototype.logAndRedirect = function (e, url, eventCode, cid, bid, pid, sid, mid, external) {
    marketId = mid;
    logEvent(eventCode, cid, bid, pid, sid);
    redirect(e, url, external);
    return false;
  };

  /**
   * Logs an event with parameters
   * @method
   * @param {Number} eventCode Event code
   * @param {*} parameters Parameters to log
   */
  EventLogger.prototype.logEventWithParameters = function (eventCode, parameters) {
    if (eventCode) {
      var url = siteRoot + routes.logEvent + eventCode;

      if (siteRoot.substring(siteRoot.length - 1) !== "/") {
        url = "/" + url;
      }

      logViewWithParameters(url, eventCode, parameters);
    }
  };

  /**
   * Logs an event with parameters and skips the ajax request to the analytics controller
   * @method
   * @param {Number} eventCode Event code
   * @param {*} parameters Parameters to log
   */
  EventLogger.prototype.logEventWithoutEcommerce = function (eventCode, parameters) {
    if (eventCode) {
      var url = siteRoot + routes.logEvent + eventCode;

      if (siteRoot.substring(siteRoot.length - 1) !== "/") {
        url = "/" + url;
      }

      logViewWithoutEcommerce(url, eventCode, parameters);
    }
  };

  /**
   * Logs an event
   * @method
   * @param {Number} eventCode Event code
   * @param {Number} cid Community Id
   * @param {Number} bid Builder Id
   * @param {Number} pid Partner Id
   * @param {Number} sid Spec Id
   */
  EventLogger.prototype.logEvent = function (eventCode, cid, bid, pid, sid) {
    if (eventCode) {
      var url = siteRoot + routes.logEvent + eventCode;

      if (siteRoot.substring(siteRoot.length - 1) !== "/") {
        url = "/" + url;
      }

      logView(url, eventCode, cid, bid, pid, sid, 0);
    }
  };

  /**
   * Executes google push functionality
   * @method
   * @param {Event[]} events Event List
   * @param {String} action Action
   * @param {String} label Label
   * @param {String | Number | Boolean} value Value
   */
  EventLogger.prototype.googlepush = function (events, action, label, value) {
    if (typeof dataLayer !== "undefined") {
      dataLayer.push({
        'event': "GAEvent",
        'eventCategory': events,
        'eventAction': action,
        'eventLabel': label,
        'eventValue': undefined
      });
    }
  };

  /**
  * Gets log info
  */
  EventLogger.prototype.getLogInfo = function () {
    const logInfo = {
      builderId: document.getElementById("BuilderId") ? parseInt(document.getElementById("BuilderId").value) : 0,
      communityId: document.getElementById("CommunityId") ? parseInt(document.getElementById("CommunityId").value) : 0,
      marketId: document.getElementById("MarketId") ? parseInt(document.getElementById("MarketId").value) : 0,
      planId: document.getElementById("PlanId") ? parseInt(document.getElementById("PlanId").value) : 0,
      specId: document.getElementById("SpecId") ? parseInt(document.getElementById("SpecId").value) : 0
    };

    return logInfo;
  };
  if (!window.jQuery) {
    window.jQuery = Object();
    window.jQuery.googlepush = EventLogger.prototype.googlepush;
  }

  return EventLogger;
});
